module.exports = __webpack_public_path__ + "static/media/YM43_7.fdc47e8d.jpg";